<!-- src/ui/pages/BotPickerPage.vue -->
<template>
  <div>
    <b-card
      class="mb-2"
      body-class="p-2"
    >
      <div class="font-weight-600">
        Meus Bots
      </div>
      <div class="small text-muted">
        Selecione um bot para editar o fluxo.
      </div>
    </b-card>

    <bot-picker :account-id="accountId" />
  </div>
</template>

<script>
import BotPicker from './BotPicker.vue'

export default {
  name: 'BotPickerPage',
  components: { BotPicker },
  computed: {
    // Pegue o accountId da sua store/autenticação; aqui lendo da query como exemplo

    accountId() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      console.log(userData.id)
      return userData.id
    },
  },
}
</script>
